import { useSpaceDetail } from '@confluence/space-utils/entry-points/useSpaceDetail.ts';

export const useSpaceType = ({
	spaceKey,
}: {
	spaceKey: any;
}): {
	spaceType: string | undefined;
	isKnowledgeBaseSpace: boolean;
} => {
	const { data: spaceData } = useSpaceDetail(spaceKey);

	return { spaceType: spaceData?.type, isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base' };
};
